import mixpanel from "mixpanel-browser";
import { getCurrentPageName } from "./helper.ts";

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || "", {
  debug: true,
  track_pageview: false,
  persistence: "localStorage",
  autocapture: false,
});

export const trackIdentity = (auth_id?: string, email?: string) => {
  if (process.env.NODE_ENV === "development") {
    console.warn("trackIdentity", {
      identify: auth_id,
      people: {
        $email: email,
      },
    });

    return null;
  }

  mixpanel.identify(auth_id);

  mixpanel.people.set({
    $email: email,
  });
};

export const trackEvent = (eventName: string, eventProperties?: Object) => {
  if (process.env.NODE_ENV === "development") {
    console.warn("trackEvent", {
      eventName,
      eventProperties,
    });

    return null;
  }

  mixpanel.track(eventName, eventProperties);
};

export const trackPage = (path: string) => {
  const pageTitle = getCurrentPageName(path).pageName;

  if (process.env.NODE_ENV === "development") {
    console.warn("trackPage", {
      eventName: "Page View",
      eventProperties: { title: pageTitle },
    });

    return null;
  }

  mixpanel.track("Page View", { title: pageTitle });
};

export const trackError = (eventName: string, eventProperties?: Object) => {
  const name = `Error: ${eventName}`;

  if (process.env.NODE_ENV === "development") {
    console.warn("trackError", {
      eventName: name,
      eventProperties,
    });

    return null;
  }

  mixpanel.track(name, eventProperties);
};
